import * as yup from 'yup';

export const VENDOR_INFO_SCHEMA = yup.object({
  name: yup
    .string()
    .required('نام فروشگاه را وارد کنید')
    .max(155, 'نام فروشگاه نمیتواند بیشتر از 155 کاراکتر باشد')
    .min(3, 'نام فروشگاه نمیتواند کمتر از 3 کاراکتر باشد'),
  postalCode: yup.string().required('کدپستی را وارد کنید').max(10, 'کدپستی باید 10 رقم باشد'),
  address: yup.string().defined(),
  softwareType: yup.string().required('نوع نرم افزار را انتخاب کنید'),
  deliveryType: yup.string().required('نحوه ارسال سفارش را انتخاب کنید')
});
